import React, { Component } from 'react';
import Slider               from 'react-slick';
import PropTypes            from 'prop-types';

import './../css/Place.css';

class PlaceImage extends Component
{
    getAltText = (image) =>
    {
        if (image.hasOwnProperty('altText') && String(image.altText).length > 0) {
            return image.altText;
        }

        return this.props.place.name;
    }

    renderImages = () =>
    {
        let { place } = this.props;

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
        };

        if (place.images.length > 1) {
            let c = 0;
            const list = place.images.map(image => {
                c++;
                return (
                    <div key={ c }>
                        <div className="place-image-container">
                            <img className="place-image" src={ image.url } alt={ this.getAltText(image) } />
                        </div>
                        <div className="place-image-text">{ image.text }</div>
                    </div>
                );
            });

            return <div className="image-carousel">
                <Slider { ...settings }>
                    { list }
                </Slider>
            </div>
        } else {
            const image = this.props.place.images[0];
            return <div className="image-carousel">
                <div className="place-image-container">
                    <img className="place-image" src={ image.url } alt={ this.getAltText(image) } />
                </div>
                <div className="place-image-text">{ image.text }</div>
            </div>
        }
    };

    render() {
        if ('images' in this.props.place && this.props.place.images.length > 0)
        {
            return this.renderImages();
        }
        else
        {
            return null;
        }
    }
}

PlaceImage.propTypes = {
    place: PropTypes.object.isRequired
};

export default PlaceImage;



// WEBPACK FOOTER //
// ./src/components/PlaceImage.js